import { createGlobalStyle } from "styled-components";

import { SCENSUM_WEBSITE_HEADER_HEIGHT } from "../../constants/constants";

export const FixedStyle = createGlobalStyle`
  .bfc-fixed {
    .BreadCrumbList {
      position: fixed;
      top: ${SCENSUM_WEBSITE_HEADER_HEIGHT};

      @media (min-width: 768px) {
          top: 0;
      }
    }
  }
`;
